import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'ScreenConfigMst',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + 'マスタ | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loading: true,
      processing: false,
      registerHash: Constants.RegisterHash,

      // テーブルオプション
      tableColumns: [
        'screenConfigMstId',
        'screenConfigName',
        'deviceTypeName',
        'serviceTypeName',
        // 'screenOrientationKbn',
        'screenConfigStatus',
        'modifyButton',
        'layoutButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          screenConfigMstId: '画面構成ID',
          screenConfigName: '画面構成名',
          deviceTypeName: '対象デバイス',
          serviceTypeName: 'サービスタイプ',
          // screenOrientationKbn: '画面方向',
          screenConfigStatus: 'ステータス',
          modifyButton: '',
          layoutButton: ''
        },
        columnsClasses: {
          screenConfigMstId: 'wp-5',
          screenConfigName: '',
          deviceTypeName: '',
          serviceTypeName: '',
          // screenOrientationKbn: '',
          screenConfigStatus: '',
          modifyButton: 'wp-5 has-button',
          layoutButton: 'wp-5 has-button'
        },
        sortable: [
          'screenConfigMstId',
          'screenConfigName',
          'deviceTypeName',
          'serviceTypeName',
          // 'screenOrientationKbn',
          'screenConfigStatus'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // 変更
      modifyTargetId: null,
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
    this.initRegister()
  },
  computed: {
    ...mapState({
      categoryName: state => state.screenConfigMst.categoryName,

      // model
      screenConfigMstModel: state => state.screenConfigMst.screenConfigMstModel,
      deviceModel: state => state.screenConfigMst.deviceModel,
      serviceTypeModel: state => state.screenConfigMst.serviceTypeModel,

      // form
      values: state => state.screenConfigMst.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone',
      isRegister: 'screenConfigMst/isRegister',
      isModify: 'screenConfigMst/isModify'
    }),

    // title
    formTitle () {
      const id = Utility.getObjectArrayValue(this.screenConfigMstModel, 'screenConfigMstUuid', this.modifyTargetId, 'screenConfigMstId')
      return this.isRegister ?
        this.categoryName + '登録' :
        this.categoryName + '変更（Id : ' + id + '）'
    },
    formButtonLabel () {
      return this.isRegister ? '登録' : '変更'
    },

    // list
    deviceList () {
      let list = []
      this.deviceModel.forEach(item => list.push({
        value: item.deviceTypeUuid,
        label: item.modelName
      }))
      return list
    },
    serviceTypeList () {
      let list = []
      this.serviceTypeModel.forEach(item => list.push({
        value: item.serviceTypeCd,
        label: item.serviceTypeName
      }))
      return list
    },
    directionList () {
      return Constants.Mst.ScreenOrientation
    },
    statusList () {
      return Constants.Status.sort(Utility.sortByKey('index', true))
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // input
    inpScreenConfigName: {
      get () {
        return this.values.inpScreenConfigName
      },
      set (value) {
        this.setInputValue({
          key: 'inpScreenConfigName',
          value: value
        })
      }
    },
    inpDeviceType: {
      get () {
        return this.values.inpDeviceType
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeviceType',
          value: value
        })
      }
    },
    inpServiceType: {
      get () {
        return this.values.inpServiceType
      },
      set (value) {
        this.setInputValue({
          key: 'inpServiceType',
          value: value
        })
      }
    },
    // inpOrientationKbn: {
    //   get () {
    //     return this.values.inpOrientationKbn
    //   },
    //   set (value) {
    //     this.setInputValue({
    //       key: 'inpOrientationKbn',
    //       value: value
    //     })
    //   }
    // },
    inpStatus: {
      get () {
        return this.values.inpStatus
      },
      set (value) {
        this.setInputValue({
          key: 'inpStatus',
          value: value
        })
      }
    },

    // validate
    inpScreenConfigNameIsValid () {
      return Validator.validText(this.inpScreenConfigName)
    },
    inpDeviceTypeIsValid () {
      return Validator.validSelect(this.inpDeviceType)
    },
    inpServiceTypeIsValid () {
      return Validator.validSelect(this.inpServiceType)
    },
    // inpOrientationKbnIsValid () {
    //   return Validator.validText(this.inpOrientationKbn)
    // },
    formIsValid () {
      return this.inpScreenConfigNameIsValid &&
        this.inpDeviceTypeIsValid &&
        this.inpServiceTypeIsValid
    },
    disablePostButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'screenConfigMst/loadModel',
      initRegister: 'screenConfigMst/initRegister',
      initModify: 'screenConfigMst/initModify',
      showLayout: 'screenConfigLayout/show',
    }),
    ...mapMutations({
      setInputValue: 'screenConfigMst/setInputValue',
    }),

    init () {
      this.loading = true

      //TODO
      let screenConfigMstParams = {}
      let deviceParams = { filters: {} }

      // データ読出し
      this.loadModel({
        screenConfigMstParams: screenConfigMstParams,
        deviceParams: deviceParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.screenConfigMstModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // ファイル登録
    confirmData() {
      const id = Utility.getObjectArrayValue(this.screenConfigMstModel, 'screenConfigMstUuid', this.modifyTargetId, 'screenConfigMstId')
      this.showConfirm({
        key: 'register',
        title: '',
        body: this.isRegister ?
          'この内容で' + this.categoryName + 'を登録しますか？' :
          '「Id : ' + id + '」の' + this.categoryName + '情報を変更しますか？'
      })
    },
    postData () {
      this.processing = true

      let parameters = {
        request: {
          screenConfigName: this.inpScreenConfigName,
          deviceTypeUuid: this.inpDeviceType,
          serviceTypeKbn: this.inpServiceType,
          // screenOrientationKbn: this.inpOrientationKbn,
          screenOrientationKbn: 0,
          screenConfigStatus: this.inpStatus
        }
      }
      if (this.isModify) {
        parameters.screenConfigMstUuid = this.modifyTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['screenConfigMst'],
        [this.isRegister ?
          'v1ScreenConfigMstPost' :
          'v1ScreenConfigMstPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.isRegister ?
                '新しい' + this.categoryName + 'の登録' :
                this.categoryName + '情報の変更',
              body: this.isRegister ?
                this.categoryName + 'を登録しました。' :
                this.categoryName + 'を変更しました。'
            })

            // this.modifyTargetId = null

            // 一覧データを再読出し
            this.init()
            this.registerItem()
          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    // 登録済み一覧
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        // case 'screenOrientationKbn':
          // return Utility.getConstantsLabel(['Mst', 'ScreenOrientation'], value)
        case 'screenConfigStatus':
          return Utility.getConstantsLabel(['Status'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    registerItem () {
      this.modifyTargetId = null
      this.initRegister()
    },
    modifyItem (props) {
      this.modifyTargetId = props.row.screenConfigMstUuid
      this.initModify({
        data: props.row
      })
    },
    layoutItem (props) {
      this.showLayout(props.row.screenConfigMstUuid)
    }
  }
}